/**
 * ProjectReplyCardConnected — wrapper que conecta hooks de project outreach al ReplyCard shared.
 * Sprint 7.6 Bloque A.
 */
import { useTranslation } from 'react-i18next';
import { ReplyCard } from '../outreach/ReplyCard.js';
import type { NormalizedReply, ReplyCardLabels } from '../outreach/types.js';
import { useComposeProjectReply, type ProjectOutreachReply } from '../../hooks/useProjectOutreach.js';

interface ProjectReplyCardConnectedProps {
  reply: ProjectOutreachReply;
  projectId: number;
}

export function ProjectReplyCardConnected({ reply, projectId }: ProjectReplyCardConnectedProps) {
  const { t } = useTranslation();
  const composeReply = useComposeProjectReply(projectId);

  const normalized: NormalizedReply = {
    id: reply.id,
    fromAddress: reply.fromAddress,
    subject: reply.subject,
    bodyText: reply.bodyText,
    receivedAt: reply.receivedAt,
    timestamp: reply.receivedAt,
    direction: 'inbound',
  };

  const labels: ReplyCardLabels = {
    inbound: t('projects.outreach.replies.inbound'),
    outbound: '',
    possible: '',
    verified: '',
    confirm: '',
    dismiss: '',
    from: t('projects.outreach.replies.from'),
    to: '',
    subject: t('projects.outreach.replies.subject'),
    received: t('projects.outreach.replies.received'),
    sent: '',
    showQuote: '',
    hideQuote: '',
    replyBtn: t('projects.outreach.reply'),
    sendReplyBtn: t('composer.send'),
    sending: t('projects.outreach.composing'),
    cancel: t('common.cancel'),
    attachBtn: '',
    sizeExceeded: '',
    replyTo: t('projects.outreach.replyTo', { to: '{to}' }),
    composerPlaceholder: t('projects.outreach.composing'),
    actionFailed: t('projects.outreach.action_failed'),
  };

  return (
    <ReplyCard
      reply={normalized}
      labels={labels}
      onReply={({ bodyHtml, bodyText }) =>
        composeReply.mutate({ replyId: reply.id, bodyHtml, bodyText })
      }
      replyState={{ isPending: composeReply.isPending, isError: composeReply.isError, error: composeReply.error, reset: composeReply.reset }}
    />
  );
}
